import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable, of } from 'rxjs';

let postStepCount = 0;

@Injectable()
export class MockLegalDocsInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isGetStep = req.method === 'GET' && req.url.includes('/legal-docs/packet/') && req.url.includes('/step');
    const isPostStep = req.method === 'POST' && req.url.includes('/legal-docs/packet/') && req.url.includes('/step');

    if (isGetStep) {
      postStepCount = 0;
      return of(new HttpResponse({
        status: 200,
        body: this._getMockResponse(0)
      }));
    }

    if (isPostStep) {
      postStepCount++;
      const stepIndex = Math.min(postStepCount, 3);
      return of(new HttpResponse({
        status: 200,
        body: this._getMockResponse(stepIndex)
      }));
    }

    return next.handle(req);
  }

  private _getMockResponse(step: number) {
    switch (step) {
      case 0:
      case 1:
        return {
          result: { code: 'SERVICE_OK' },
          payload: {
            documentGroupKey: `mock_group_step_${step}`,
            titleCopy: `mock step ${step} title`,
            descriptionCopy: `mock step ${step} description`,
            deferrable: false,
            legalDocuments: [
              {
                titleCopyKey: `mock.step${step}.title`,
                descriptionCopyKey: `mock.step${step}.desc`,
                downloadUrlCopyKey: `mock.step${step}.url`,
                downloadUrl: `https://example.com/doc-step${step}.pdf`,
                documentVersionId: 100 + step
              }
            ]
          }
        };
      case 2:
        return {
          result: { code: 'SERVICE_OK' },
          payload: {
            documentGroupKey: `mock_group_step_2`,
            deferrable: true,
            legalDocuments: [
              {
                titleCopyKey: 'mock.step2.title',
                descriptionCopyKey: 'mock.step2.desc',
                downloadUrlCopyKey: 'mock.step2.url',
                downloadUrl: 'https://example.com/doc-step2.pdf',
                documentVersionId: 102
              },
              {
                titleCopyKey: 'mock.step2.title.2',
                descriptionCopyKey: 'mock.step2.desc.2',
                downloadUrlCopyKey: 'mock.step2.url.2',
                downloadUrl: 'https://example.com/doc-step2b.pdf',
                documentVersionId: 103
              }
            ]
          }
        };
      case 3:
        return {
          result: { code: 'SERVICE_OK' },
          payload: {
            documentGroupKey: 'mock_group_step_final',
            deferrable: false,
            legalDocuments: []
          }
        };
    }
  }
}
